"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TranslateAware", {
  enumerable: true,
  get: function get() {
    return _TranslateAware.TranslateAware;
  }
});

var _TranslateAware = require("./TranslateAware");